import React, { Component } from 'react';
import WithRouter from 'custom/withRouter';
import PurchaseOrderList from './PurchaseOrderList';
import PurchaseOrderSave from './PurchaseOrderSave';

// TODO: Write some comments here about what each section is doing
class PurchaseOrderPage extends Component {

    constructor(props, context) {
        super(props, context);
    }

    callListView = () => {
        this.props.navigate("/purchaseorder");
    }

    callSaveView = () => {
        this.props.navigate("/purchaseorder/add");
    }

    // This page renders either Product List or Product Save
    render() {
        const poId = this.props.params.id;
        const isSave = poId || this.props.location.pathname === "/purchaseorder/add";

        return (
            <div>
                {
                    isSave ?
                        <PurchaseOrderSave name="POSave"
                            callListView={this.callListView}
                            params={this.props.params} />
                        :
                        <PurchaseOrderList callSaveView={this.callSaveView} />
                }
            </div>
        );
    }
}

export default WithRouter(PurchaseOrderPage);